module.exports = __webpack_public_path__ + "img/caigou-cover.63fcd16c.png";